"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TableHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function TableHeader(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
            {
                flexDirection: 'row',
                justifyContent: 'center',
                paddingVertical: 4,
                backgroundColor: THEME.SmokeWhite,
                borderRadius: 2
            },
            props.style
        ], children: props.columns != null &&
            props.columns.length > 0 &&
            props.columns.map((c, i) => {
                const isSortable = !!c?.sortKey && !!props?.onSort;
                const isSorted = props?.sort?.field === c?.sortKey;
                const sortDirection = isSorted ? props?.sort?.direction : null;
                const Wrapper = isSortable ? react_native_1.Pressable : react_native_1.View;
                const wrapperProps = isSortable ? { onPress: () => props?.onSort(c?.sortKey) } : {};
                return ((0, jsx_runtime_1.jsx)(Wrapper, { ...wrapperProps, style: [
                        {
                            justifyContent: 'center',
                            flex: c.flex,
                            alignItems: c.align ?? 'center',
                        },
                        c.viewStyle
                    ], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', paddingLeft: c.align == 'flex-end' ? 0 : (c.indent ?? 0), paddingRight: c.align == 'flex-end' ? (c.indent ?? 0) : 0 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": c.accLabel ?? c.label, style: [
                                    {
                                        fontSize: size != 'sm' ? 14 : 12,
                                        fontWeight: '500',
                                        textAlign: c.align == 'center' ? 'center' : null,
                                        color: THEME.SmokeWhiteText,
                                    },
                                    c.textStyle
                                ], children: c.label }), isSortable && isSorted && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: sortDirection === 'asc' ? Theme_1.ICONS.Regular.ChevronUp : Theme_1.ICONS.Regular.ChevronDown, size: 12, color: THEME.SmokeWhiteText, style: { marginLeft: 4, marginTop: sortDirection === 'asc' ? 2 : 0 } }))] }) }, i));
            }) }));
}
;
